import { getApiUrl } from "../utils/get-api-url";
import parse from "../utils/xml-parsers/agency";

export const getOrganization = async ({ alc }) => {
  const apiUrl = getApiUrl("ixdirectory");
  const fullUrl = `${apiUrl}/organizations/${alc}`;

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include"
  });
  const { statusText, ok } = response;
  const xml = await response.text();
  if (!ok) throw new Error(xml.message || statusText);
  return parse(xml);
};
